import React from 'react';
import final from '../Asserts/final.png';
import { useNavigate } from 'react-router-dom';

function Final() {

  const navigate = useNavigate();

  const handleclick = () => {
    navigate('/contact')
  }
 
  return (
    <div className="flex flex-col md:flex-row items-center justify-center text-center md:text-left bg-gray-100 py-10 px-6 rounded-lg ">
      <div className="md:w-1/2  text-center">
        <h2 className="text-3xl font-bold text-[#FF6F00] mb-4">
          Start Your Loan Search Today
        </h2>
        <p className="text-lg text-gray-700  mb-6 ">
          Find the perfect loan solution for your financial needs.
        </p>
        <button
          onClick={handleclick}
          className="bg-[#FF6F00] hover:bg-[#E65C00] transition duration-300 ease-in-out text-white font-bold py-3 px-6 rounded-lg shadow-md">
          Get Started
        </button>
      </div>
      <div className="md:w-1/2 flex justify-center">
        <img src={final} alt="Loan Search" className="w-full max-w-sm " />
      </div>
    </div>
  );
}

export default Final;
